<template>

    <div id="visualizarEditarAula">

        <vuestic-widget headerText="Visualizar e Editar - Aula Prática">

            <div class="row pt-3 text-center font-small">

                <div style="display: flex" class="col-md-6 p-0">
                    
                    <div v-if="aula.foto === ''" class="col">
                        <img src="@/assets/profile_ead.png" style="width: 80px; border-radius: 50%;">
                    </div>

                    <div v-else class="col">
                        <img :src="'data:image/jpeg;base64, ' + aula.foto" style="width: 120px; height: 120px; border-radius: 10%; border: 3px solid #ddd; object-fit: cover;">
                    </div>

                    <div class="col">
                        <strong class="font-weight-bold">Aluno</strong>
                        <span style="overflow: hidden;" class="input-group-text mt-2">{{ aula.nome }}</span>
                    </div>

                    <div class="col">
                        <strong class="font-weight-bold">Instrutor</strong>
                        <span style="overflow: hidden;" class="input-group-text mt-2">{{ aula.instrutor }}</span>
                    </div>

                </div>

                <div class="col-md-2">
                    <strong class="font-weight-bold">Turno</strong>
                    <span style="overflow: hidden;" class="input-group-text mt-2">{{ aula.turno }}</span>
                </div>

                <div class="col-md-2">
                    <strong class="font-weight-bold">Veículo</strong>
                    <span style="overflow: hidden;" class="input-group-text mt-2">{{ aula.placaVeiculo }}</span>
                </div>

                <div class="col-md-2">
                    <strong class="font-weight-bold">Categoria</strong>
                    <span style="overflow: hidden;" class="input-group-text mt-2">{{ aula.categoria }}</span>
                </div>


            </div>

            <hr class="my-4">

            <div class="row pt-3 text-center font-small">

                <div class="col-md-2">
                    <strong class="font-weight-bold">Início da Aula (Previsto)</strong>
                    <span style="overflow: hidden;" class="input-group-text mt-2">{{ aula.data }}</span>
                </div>

                <div class="col-md-2">
                    <strong class="font-weight-bold">Tempo de Aula (Previsto)</strong>
                    <span style="overflow: hidden;" class="input-group-text mt-2">50 minutos</span>
                </div>

                <div class="col-md-2">
                    <strong class="font-weight-bold">Fim da Aula (Previsto)</strong>
                    <span style="overflow: hidden;" class="input-group-text mt-2">{{ aula.hora_fim }}</span>
                </div>

                <div v-if="!aula.horario_inicio_fim" class="col-md-6">
                </div>
                <div v-else style="display: flex" class="col-md-6 p-0">
                    
                    <div class="col-md-4">
                        <strong class="font-weight-bold">Início da Aula (Real)</strong>
                        <span style="overflow: hidden;" class="input-group-text mt-2">{{ aula.horario_inicio_fim[0] }}</span>
                    </div>

                    <div class="col-md-4">
                        <strong class="font-weight-bold">Tempo de Aula (Real)</strong>
                        <span style="overflow: hidden;" class="input-group-text mt-2">50 minutos</span>
                    </div>

                    <div class="col-md-4">
                        <strong class="font-weight-bold">Fim da Aula (Real)</strong>
                        <span style="overflow: hidden;" class="input-group-text mt-2">{{ aula.horario_inicio_fim[1] }}</span>
                    </div>

                </div>

            </div>


            <hr class="my-4 mt-3">

            <div class="row pt-3">

                <fieldset class="col-md-3 mb-3">
                    <SelectIconGroup iconInput="fa-user" idInput="id_instrutor" labelInput="Instrutor" :optionsInput="optionsInputIstrutor">
                    </SelectIconGroup>
                </fieldset>

                <fieldset class="col-md-3 mb-3">
                    <SelectIconGroup iconInput="fa-car" idInput="id_veiculo" labelInput="Veiculo" :optionsInput="optionsInputVeiculo">
                    </SelectIconGroup>
                </fieldset>

                <fieldset class="col-md-2" id="periodoConsultado">
                    <DateIconGroup idInput="data_aula" iconInput="fa-calendar" labelInput="Data da Aula" :enableTime="true">
                    </DateIconGroup>
                </fieldset>

                <div class="col-md-2 text-right" id="btnUpdateClass">
                    <button @click="actionModalUpdate()" class="btn btn-success col-12 btn-micro disabled" aria-disabled="true">
                        <i class="fa fa-save pr-3 icon-branco"></i>
                        <span class="font-button-modified">Atualizar</span>
                    </button>
                </div>
                <div class="col-md-2 text-right">
                    <button @click="close('close')" class="btn btn-danger col-12 btn-micro" aria-disabled="true">
                        <i class="fa fa-times pr-3 icon-branco"></i>
                        <span class="font-button-modified">Fechar</span>
                    </button>
                </div>

            </div>

            <!-- MODAL ATUALIZAR -->
            <div v-if="showModalUpdate">
                <transition name="modal">
                    <div class="modal-mask">
                        <div class="modal-wrapper">
                            <div class="modal-container">

                            <div class="modal-header">
                                <slot name="header">
                                    <h3>Confirmar</h3>
                                </slot>
                            </div>

                            <div class="modal-body">
                                <slot name="body">
                                    Deseja realmente atualizar essa aula?
                                </slot>
                            </div>

                            <div class="modal-footer">
                                <slot name="footer">
                                    <button class="modal-default-button btn btn-danger btn-micro" @click="actionModalUpdate()">
                                        Não
                                    </button>
                                    <button class="modal-default-button btn btn-success btn-micro" @click="updateClass()">
                                        Sim
                                    </button>
                                </slot>
                            </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>

            <span v-for="item in teste" :key="item.id">
                {{ item.text }}
            </span>

        </vuestic-widget>
    </div>
</template>

<script>
import urlApi from '@/router/urlApiV2'
import * as spinners from 'epic-spinners'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import SelectIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'

export default {
    name: 'AulaPratica',
    components: {
        urlApi,
        ...spinners,
        DateIconGroup,
        SelectIconGroup,
    },
    props: {
        schema: {
            required: true,
        },
        id_aula: {
            required: true,
        },
    },
    
    data () {
        return {
            aula: [],
            optionsInputIstrutor: [{
                id: '',
                value: 'Selecione um instrutor'
            }],
            optionsInputVeiculo: [{
                id: '',
                value: 'Selecione um veículo'
            }], 
            showModalUpdate: false,
            teste: ''
        }
    },

    mounted() {

        this.loadData();

    },

    methods: {

        loadData()
        {
            this.optionsInputIstrutor = [{
                id: '',
                value: 'Selecione um instrutor'
            }]
            this.optionsInputVeiculo = [{
                id: '',
                value: 'Selecione um veículo'
            }]

            this.$http.get(urlApi + '/aulas/praticas/autoescola/' + this.schema + '/id/' + this.id_aula).then(response => {

                this.loadTable = false;
                this.aula = response.data.dados;

                response.data.instrutor.map(item => {
                    this.optionsInputIstrutor.push({
                        id: item.id_instrutor,
                        value: item.nome
                    })
                });

                response.data.veiculos.map(item => {
                    this.optionsInputVeiculo.push({
                        id: item.id_veiculo,
                        value: item.placa,
                        categoria: item.categoria.categoria_cnh
                    })
                });


            }).catch(function (error) {
                this.$toasted.show(error.data.mensagem, {
                    position: 'top-right',
                });
                this.loadTable = false;
                this.aulas = ''
            })
        },

        actionModalUpdate()
        {
            if(this.showModalUpdate === true) {
                // console.log('fechar modal')
                this.showModalUpdate = false;
            } else {
                // console.log('abrir modal')
                this.showModalUpdate = true;
            }
        },

        updateClass()
        {
            this.schema = this.$route.params.schema;
            this.id_aula = this.$route.params.id;

            var data = {
                idInstrutor: document.getElementById("id_instrutor").value,
                idVeiculo: document.getElementById("id_veiculo").value,
                data: document.getElementById("data_aula").value
            };

            this.$http.put(urlApi + '/aulas/praticas/editar/autoescola/' + this.schema + '/id/' + this.id_aula, data).then(response => {
                
                this.$toasted.show(response.body.mensagem, {
                    position: 'top-right',
                });

                this.loadData();
                this.actionModalUpdate();

            }).catch(function (error) {

                this.$toasted.show(error.body.mensagem, {
                    position: 'top-right',
                });

            });
        },
        close(){
            this.$emit('goBack')
        }

    },

}
</script>

<style lang="scss" scoped>
    #visualizarEditarAula {

        .form-group
        {
            margin: 0 !important;
        }
        
        .form-group input, .form-group textarea
        {
            padding: 0;
            line-height: 2;
        }
        
        .form-group input, .form-group textarea.chat
        {
            height: auto;
        }
        
    }

    .font-small strong
    {
    font-size: 15px;
    }

    .font-small span
    {
    font-size: 14px;
    }

    .btn.btn-success
    {
        background-color: #20c997;
        border-color: #20c997;
        box-shadow: 0 4px 9.6px 0.4px #21252938 !important;
    }
    
    .btn.btn-success:hover
    {
        background-color: #20c9968e;
    }

    .espacamento-oculto
    {
    color: transparent !important;
    user-select: none;
    margin-top: -1px;
    }

    // ESTILIZAÇÃO PARA MODAL
    .modal-mask
    {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    }

    .modal-wrapper
    {
    display: table-cell;
    vertical-align: middle;
    }

    .modal-container
    {
    width: 350px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3
    {
    margin-top: 0;
    color: #34495e;
        text-align: center;
    }

    .modal-body
    {
    margin: 10px 0;
    }

    .modal-default-button
    {
    float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter
    {
    opacity: 0;
    }

    .modal-leave-active
    {
    opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container
    {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    }
</style>